import { CrossClientQueryExecution, CrossClientQueryExecutionProgress, CrossClientQueryPhase, CrossClientQueryPhases } from '../../models/CrossClient'

export const CROSS_EXECUTION_CLIENT_RUNNING_PHASES: Set<CrossClientQueryPhase> = new Set([CrossClientQueryPhases.PROCESSING, CrossClientQueryPhases.QUEUED])

export const CROSS_EXECUTION_CLIENT_FINISHED_PHASES: Set<CrossClientQueryPhase> = new Set([CrossClientQueryPhases.COMPLETED, CrossClientQueryPhases.CANCELED])

export const executionIsRunning = (execution?: CrossClientQueryExecution | CrossClientQueryExecutionProgress | null) => {
  return !!execution && CROSS_EXECUTION_CLIENT_RUNNING_PHASES.has(execution.phase)
}
